/* unplugin-vue-components disabled */import { render } from "./NavbarReloadConfig.vue?vue&type=template&id=1876cac9&ts=true"
import script from "./NavbarReloadConfig.vue?vue&type=script&lang=ts"
export * from "./NavbarReloadConfig.vue?vue&type=script&lang=ts"

import "./NavbarReloadConfig.vue?vue&type=style&index=0&id=1876cac9&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__